/* =====================================================================
   TEXAS JAILHOUSE — homepage interactions
   Works across independent Shopify sections (each a .txj wrapper).
   Safe to run in the theme editor (re-inits on section load).
   ===================================================================== */
(function () {
  function init() {
    var doc = document;

    /* ---- reveal on scroll ---- */
    var revealEls = doc.querySelectorAll('.txj-reveal:not([data-txj-observed])');
    if (revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('txj-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      revealEls.forEach(function (el) { el.setAttribute('data-txj-observed', '1'); io.observe(el); });
    }

    /* ---- FAQ accordions ---- */
    doc.querySelectorAll('.txj-faq-q:not([data-txj-bound])').forEach(function (q) {
      q.setAttribute('data-txj-bound', '1');
      q.addEventListener('click', function () {
        var item = q.closest('.txj-faq-item');
        var ans = item.querySelector('.txj-faq-a');
        var open = item.classList.toggle('txj-open');
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : null;
      });
    });

    /* ---- live clock (hero HUD) ---- */
    var clocks = doc.querySelectorAll('.txj-clock:not([data-txj-bound])');
    if (clocks.length) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var d = new Date();
        var t = pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear() + ' ' +
          pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
        clocks.forEach(function (c) { c.textContent = t; });
      };
      clocks.forEach(function (c) { c.setAttribute('data-txj-bound', '1'); });
      tick();
      if (!window.__txjClock) { window.__txjClock = setInterval(tick, 1000); }
    }

    /* ---- current year ---- */
    doc.querySelectorAll('.txj-year').forEach(function (y) { y.textContent = new Date().getFullYear(); });

    /* ---- history timeline (spine fill + active nodes) ---- */
    doc.querySelectorAll('.txj-timeline:not([data-txj-bound])').forEach(function (tl) {
      tl.setAttribute('data-txj-bound', '1');
      var spine = tl.querySelector('.txj-spinefill');
      var items = [].slice.call(tl.querySelectorAll('.txj-titem'));
      var tio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('txj-in'); });
      }, { threshold: 0.3 });
      items.forEach(function (el) { tio.observe(el); });
      var ticking = false;
      var update = function () {
        var r = tl.getBoundingClientRect();
        var mid = window.innerHeight * 0.5;
        var pr = Math.max(0, Math.min(1, (mid - r.top) / r.height));
        if (spine) spine.style.height = (pr * 100) + '%';
        var target = window.innerHeight * 0.58;
        items.forEach(function (el) {
          var n = el.querySelector('.txj-tnode').getBoundingClientRect();
          el.classList.toggle('txj-active', n.top < target && n.top > -50);
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* ---- smooth scroll for in-page anchors ---- */
    doc.querySelectorAll('a[href^="#txj-"]:not([data-txj-bound])').forEach(function (a) {
      a.setAttribute('data-txj-bound', '1');
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length > 1) {
          var t = doc.querySelector(id);
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      });
    });

    /* ---- custom header: sticky state + mobile drawer ---- */
    var header = doc.querySelector('[data-txj-header]');
    if (header && !header.__txjBound) {
      header.__txjBound = true;
      var onScroll = function () { header.classList.toggle('txj-scrolled', window.scrollY > 20); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      var menuBtn = doc.getElementById('txjMenu');
      var links = doc.getElementById('txjLinks');
      var scrim = doc.getElementById('txjScrim');
      var setMenu = function (open) {
        if (!links) return;
        links.classList.toggle('txj-open', open);
        if (scrim) scrim.classList.toggle('txj-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
        if (menuBtn) { menuBtn.setAttribute('aria-expanded', open); menuBtn.innerHTML = open ? '&#10005;' : '&#9776;'; }
      };
      if (menuBtn && links) {
        menuBtn.addEventListener('click', function () { setMenu(!links.classList.contains('txj-open')); });
        links.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      }
      if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
      window.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
      window.addEventListener('resize', function () { if (window.innerWidth > 860) setMenu(false); });
    }

    /* ---- keep header cart count in sync after ajax add-to-cart ---- */
    var bubbles = doc.querySelectorAll('[data-txj-cart-count]');
    if (bubbles.length) {
      var updateCount = function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            bubbles.forEach(function (b) {
              b.textContent = c.item_count;
              if (c.item_count > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
            });
          }).catch(function () {});
      };
      var drawer = doc.getElementById('cart-drawer') || doc.querySelector('cart-drawer');
      if (drawer && !drawer.__txjObserved) {
        drawer.__txjObserved = true;
        new MutationObserver(function () { updateCount(); }).observe(drawer, { childList: true, subtree: true });
      }
      document.addEventListener('cart:refresh', updateCount);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
